module.exports = function ($timeout) {
    return {
        restrict: 'A',
        scope: {
            hasScrolledIntoView: '&',
            scrollThreshold: '@?'
        },
        link: function(scope, element) {
            let hasTriggered = false;
            let timer = null;
            const threshold = parseFloat(scope.scrollThreshold) || 0.5;
            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (hasTriggered) return;

                    if (entry.intersectionRatio >= threshold) {
                        timer = $timeout(() => {
                            hasTriggered = true;
                            scope.$apply(() => {
                                scope.hasScrolledIntoView();
                            });
                            observer.disconnect();
                        }, 1000);
                    } else {
                        if (timer) {
                            $timeout.cancel(timer);
                            timer = null;
                        }
                    }
                });
            }, {
                threshold: [0, threshold, 1]
            });

            observer.observe(element[0]);

            scope.$on('$destroy', function() {
                if (timer) $timeout.cancel(timer);
                observer.disconnect();
            });
        }
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/wowcommon/scrolledIntoView/scrolled-into-view-directive.js
 **/